import { render, staticRenderFns } from "./MensagemSemResultados.vue?vue&type=template&id=76cd513d&scoped=true&"
import script from "./MensagemSemResultados.vue?vue&type=script&lang=js&"
export * from "./MensagemSemResultados.vue?vue&type=script&lang=js&"
import style0 from "./MensagemSemResultados.vue?vue&type=style&index=0&id=76cd513d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cd513d",
  null
  
)

export default component.exports